module.exports = __webpack_public_path__ + "static/media/vat-border.e19a761d.png";